import './style.css'
import './polyfills'
import { setupViewer } from './viewer'

setupViewer()
